const ITEMS = [
  "Laboratorio clínico",
  "Resultados el mismo día",
  "Atención personalizada",
  "Doppler en tiempo real",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-slate-800 bg-black py-5"
  >
    <div className="marquee-track flex w-max items-center">
      {[...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-slate-400"
        >
          <span className="px-8">{item}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
